/**
 * Разделы портала после «Сегодня» и «Накладных» — по папке на раздел.
 *
 * Зачем реестр: разделы строятся параллельно, и каждый трогает только свою
 * папку `sections/<код>/` — экран (`index.tsx`), готовность (`meta.ts`),
 * показ без сервера (`mock.ts`). Меню, маршруты и общий mock берут всё
 * отсюда, поэтому общие файлы портала при добавлении раздела не правятся.
 */

import type { ComponentType } from 'react';
import type { Navigation, PortalRequest } from '../api';

import Payments from './payments';
import { READY as PAYMENTS_READY } from './payments/meta';
import { mock as paymentsMock } from './payments/mock';
// «Сверка» — вкладки «Оплат» с 21.10.2026 (D267): своего экрана в реестре
// у неё нет, а показ без сервера остаётся — его адреса `/api/reconcile/*`.
import { mock as reconcileMock } from './reconcile/mock';
import Shift from './shift';
import { READY as SHIFT_READY } from './shift/meta';
import { mock as shiftMock } from './shift/mock';
import Finance from './finance';
import { READY as FINANCE_READY } from './finance/meta';
import { mock as financeMock } from './finance/mock';
import Stock from './stock';
import { READY as STOCK_READY } from './stock/meta';
import { mock as stockMock } from './stock/mock';
import Study from './study';
import { READY as STUDY_READY } from './study/meta';
import { mock as studyMock } from './study/mock';
import Team from './team';
import { READY as TEAM_READY } from './team/meta';
import { mock as teamMock } from './team/mock';
import Accountant from './accountant';
import { READY as ACCOUNTANT_READY } from './accountant/meta';
import { mock as accountantMock } from './accountant/mock';
import Settings from './settings';
import { READY as SETTINGS_READY } from './settings/meta';
import { mock as settingsMock } from './settings/mock';

export type SectionCodeName =
  | 'payments'
  | 'shift'
  | 'finance'
  | 'stock'
  | 'study'
  | 'team'
  | 'accountant'
  | 'settings';

export const SECTION_SCREENS: Record<SectionCodeName, ComponentType<{ nav: Navigation }>> = {
  payments: Payments,
  shift: Shift,
  finance: Finance,
  stock: Stock,
  study: Study,
  team: Team,
  accountant: Accountant,
  settings: Settings,
};

export const SECTION_READY: Record<SectionCodeName, boolean> = {
  payments: PAYMENTS_READY,
  shift: SHIFT_READY,
  finance: FINANCE_READY,
  stock: STOCK_READY,
  study: STUDY_READY,
  team: TEAM_READY,
  accountant: ACCOUNTANT_READY,
  settings: SETTINGS_READY,
};

type SectionMock = (path: string, options: PortalRequest) => Promise<unknown | undefined>;

export const SECTION_MOCKS: SectionMock[] = [
  paymentsMock,
  reconcileMock,
  shiftMock,
  financeMock,
  stockMock,
  studyMock,
  teamMock,
  accountantMock,
  settingsMock,
];
